export default ({
  result: { id },
}) => [{ customerID: id }];
